import { Link } from 'react-router-dom';
import logo from '../anchor-park-logo-small.png';
import photo from '../anchor-park-image.png';
import { CONSULTING_URL, CONTACT_EMAIL, DJM_BUILD_URL, INSTAGRAM_URL } from '../site';

function HomePage() {
  return (
    <main className="Page Page--home">
      <header className="App-header">
        <p className="UnderConstruction" role="status">
          Under construction — we&apos;re just getting started
        </p>
        <img
          src={logo}
          alt="Anchor Park Homes"
          className="Page-hero-logo"
        />
        <p className="Page-lead">
          A unique opportunity to live in your own brand new home, built by
          dedicated local craftsmen in an idyllic Devon village.
        </p>

        <section className="Panel Panel--about" aria-labelledby="about-heading">
          <h2 id="about-heading" className="Panel-heading">
            A new family-run business
          </h2>
          <p className="Panel-text Panel-text--emphasis">
            <strong>AnchorPark Homes</strong> is a new family-run business
            bringing quality new homes to Devon. We are starting with sites for{' '}
            <strong>two semi-detached houses</strong>, available in{' '}
            <strong>2027</strong>, followed by <strong>more developments in 2028</strong>.
          </p>
          <ul className="Timeline" aria-label="Development timeline">
            <li className="Timeline-item">
              <span className="Timeline-year">2027</span>
              <span className="Timeline-detail">
                Two semi-detached houses — our first homes available
              </span>
            </li>
            <li className="Timeline-item">
              <span className="Timeline-year">2028</span>
              <span className="Timeline-detail">
                Further developments across additional sites
              </span>
            </li>
          </ul>
          <p className="Panel-actions">
            <Link to="/development-site" className="Button">
              Our first builds
            </Link>
            <Link to="/build-progress" className="Button">
              Build progress
            </Link>
          </p>
        </section>

        <section className="Panel" aria-labelledby="founders-heading">
          <h2 id="founders-heading" className="Panel-heading">
            Our founders
          </h2>
          <p className="Panel-text">
            Founder <strong>Daniel Martin</strong> has been working in the
            industry for 25 years and has completed many new builds,
            renovations, and extensions through his sole-trader business{' '}
            <strong>DJM Roofing and Build</strong>. See{' '}
            <a href={DJM_BUILD_URL} target="_blank" rel="noopener noreferrer">
              djmbuild.co.uk
            </a>{' '}
            and our{' '}
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer">
              Instagram
            </a>{' '}
            for more details and pictures of completed projects.
          </p>
          <p className="Panel-text">
            Co-founder <strong>Andrew Smale</strong> is an entrepreneur and
            highly experienced consultant, having worked with some of the biggest
            names in Britain on IT projects. See our sister site{' '}
            <a
              href={CONSULTING_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              anchorparkconsulting.com
            </a>{' '}
            for more details.
          </p>
          <p className="Panel-actions">
            <a
              href={DJM_BUILD_URL}
              className="Button Button--secondary"
              target="_blank"
              rel="noopener noreferrer"
            >
              DJM Roofing and Build
            </a>
            <a
              href={INSTAGRAM_URL}
              className="Button Button--secondary"
              target="_blank"
              rel="noopener noreferrer"
            >
              DJM on Instagram
            </a>
            <a
              href={CONSULTING_URL}
              className="Button Button--secondary"
              target="_blank"
              rel="noopener noreferrer"
            >
              AnchorPark Consulting
            </a>
            <Link to="/example-work" className="Button">
              View example work
            </Link>
          </p>
        </section>

        <p className="Page-contact">
          Contact{' '}
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
        </p>
        <img
          src={photo}
          alt="Anchor Park development"
          className="Page-hero-photo"
        />
        <a
          className="App-link"
          href="https://anchorparkhomes.co.uk"
          target="_blank"
          rel="noopener noreferrer"
        >
          Anchor Park Homes
        </a>
      </header>
    </main>
  );
}

export default HomePage;
